import baseAPI from '@/api';
import { UserPasskey } from '@/models/user-passkey';

export async function fetchDeletePassKey(id: number) {
  const response = await baseAPI.delete<UserPasskey>(`/passkeys/${id}`);

  return response.data;
}
